import { Observable } from 'rxjs';
import { IGuestToken } from '../auth/guest-token.interface';
import { AAGUID } from '@interticket/core';
import { IUserProfile } from '../user/user-profile.interface';
import { IAdminPartner } from './admin-partner.interface';
import { Customer } from '../../models/customer/customer.model';

export abstract class IIamSource {

  abstract fetchFeatures(): Observable<string[]>;
  abstract fetchGuestToken(userId?: AAGUID): Observable<IGuestToken>;
  abstract getProfile(): Observable<IUserProfile>;
  abstract updateCustomerDatas(customer: Customer): Observable<Response>;
  abstract getAdminPartners(): Observable<IAdminPartner[]>;

}
